import { COLUMN_INFO, COLUMN_TITLES } from './copy';

/**
 * The matrix's column model. Nothing here hardcodes a role: `permissionOptions`
 * is the same list the Create User wizard reads, so the two screens cannot
 * disagree about which roles exist or which are mutually exclusive.
 *
 * A single role is one column. A group is two — the checkbox that turns it on
 * and the tier saying which of its choices applies — which is how the design's
 * ASSET MGMT. and MGMT. ROLE relate.
 */

export const ACCOUNT_COLUMN = 'account';
export const TIER_SUFFIX = ':tier';

export const DISCOVERABILITY_KEYS = [
  'visibleAsExternalRecipient',
  'visibleAsInternalRecipient',
];

const titleFor = (option) => COLUMN_TITLES[option.id] || option.label;

const roleColumns = (permissionOptions) =>
  permissionOptions.flatMap((option) => {
    const column = {
      key: option.key || option.id,
      title: titleFor(option),
      band: 'permissions',
      type: option.choices ? 'group' : 'role',
      option,
    };

    if (!option.choices) {
      return [column];
    }

    return [
      column,
      {
        key: `${option.id}${TIER_SUFFIX}`,
        title: COLUMN_TITLES.tier,
        band: 'permissions',
        type: 'tier',
        option,
      },
    ];
  });

const discoverabilityColumns = () =>
  DISCOVERABILITY_KEYS.map((key) => ({
    key,
    title: COLUMN_TITLES[key],
    info: COLUMN_INFO[key],
    band: 'discoverability',
    type: 'discoverability',
  }));

export const buildColumns = (permissionOptions = []) => [
  {
    key: ACCOUNT_COLUMN,
    title: COLUMN_TITLES.account,
    band: null,
    type: 'account',
  },
  ...roleColumns(permissionOptions),
  ...discoverabilityColumns(),
];

/**
 * The header's top tier: consecutive columns sharing a band collapse into one
 * spanning cell. Derived rather than declared so a role added server-side widens
 * PERMISSIONS by itself.
 *
 * @returns {Array<{band: ?string, span: number}>}
 */
export const buildBands = (columns) =>
  columns.reduce((bands, column) => {
    const last = bands[bands.length - 1];

    if (last && last.band === column.band) {
      last.span += 1;

      return bands;
    }

    return [...bands, { band: column.band, span: 1 }];
  }, []);
